export const ProgressCircleSize = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
} as const;
export type ProgressCircleSize =
  (typeof ProgressCircleSize)[keyof typeof ProgressCircleSize];
